var map = {
	"./aura.png": "69f8",
	"./bannerSecundary.png": "c124",
	"./bannerSecundaryMobile.png": "1c7e",
	"./catalogo.png": "e47b",
	"./icone-question.png": "79c0",
	"./imprimax-logo-fundo-branco.png": "1e7e",
	"./imprimax_logo.png": "f724",
	"./imprimax_white_logo.png": "fb85",
	"./logo-imprimax.png": "0191"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";